import { IdNameDto } from '@app/store/shared/models';

export class UserLookup {
    readonly id: string;
    readonly name: string;

    constructor(dto: IdNameDto) {
        this.id = dto.id;
        this.name = dto.name;
    }
}
